import { TableDefine } from '@/libs/tableHelper/type'
import { GenealogyApply } from '@/api/genealogy/GenealogyApply'
import { User } from '@/api/user/User'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<GenealogyApply> {
  const tableCols = [
    {
      title: '创建人姓名',
      key: 'name'
    },
    {
      title: '创建人手机',
      key: 'phone'
    },
    {
      title: '族谱名称',
      key: 'genealogyName'
    },
    {
      title: '姓氏',
      key: 'genealogyName'
    },
    {
      title: '城市',
      key: 'city'
    },
    {
      title: '地址',
      minWidth: 150,
      key: 'address'
    },
    {
      title: '简介',
      minWidth: 200,
      key: 'introduction'
    },
    {
      title: '创建时间',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD HH:mm:ss'
      },
      key: 'createTime'
    }
  ]

  return {
    tableCols
  }
}
